import {Component, Inject, OnInit} from '@angular/core';
import {DisplayedProduct} from "app/models/menu.model";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {BaseModalComponent} from "app/shared/base-modal/base-modal.component";

@Component({
  selector: 'app-select-modifiers-modal',
  templateUrl: './select-modifiers-modal.component.html',
  styleUrls: ['./select-modifiers-modal.component.scss']
})
export class SelectModifiersModalComponent extends BaseModalComponent implements OnInit {
  isLoading: boolean;
  selectedIds: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectModifiersModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: SelectModifiersModalData,
  ) {
    super(dialogRef);
  }

  ngOnInit(): void {
    this.selectedIds = [...this.data.modifierIds];
  }

  handleCheckProduct(product: DisplayedProduct, checked: boolean) {
    if (checked) {
      this.selectedIds.push(product.externalId)
    } else {
      this.selectedIds = this.selectedIds.filter(id => id !== product.externalId)
    }
  }

  isSelectedProduct(product: DisplayedProduct) {
    return this.selectedIds.includes(product.externalId)
  }

  save() {
    this.exit([...new Set(this.selectedIds)]);
  }
}

export interface SelectModifiersModalData {
  title: string;
  modifierIds: string[];
  modifiers: DisplayedProduct[];
}
